// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__27Wh9","label":"LabeledBox_label__1CvXL"};